export function ZoomIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11 4.875a6.125 6.125 0 100 12.25 6.125 6.125 0 000-12.25zM3.125 11a7.875 7.875 0 1113.882 5.093l3.2 3.2a1 1 0 01-1.414 1.414l-3.264-3.264A7.839 7.839 0 0111 18.875a7.853 7.853 0 01-5.549-2.287A7.853 7.853 0 013.125 11zM11 6.333c.368 0 .667.299.667.667v3.333H15a.667.667 0 110 1.334h-3.333V15a.667.667 0 01-1.334 0v-3.333H7a.667.667 0 010-1.334h3.333V7c0-.368.299-.667.667-.667z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
